import React from 'react';
import { PropTypes } from 'prop-types';

import { constants as aditionalOptionsConstants } from 'utils/aditionalOptions';

import AditionalOption from 'components/summary/AditionalOption';
import DiffInsured from 'components/summary/DiffInsured';
import orderConstants from 'utils/order/constants';

const OPTIONS = {
  [orderConstants.DIRECT_ORDER]: [
    aditionalOptionsConstants.ADITIONAL_OPTIONS.COMMENT_FOR_TRANSPORTIST,
    aditionalOptionsConstants.ADITIONAL_OPTIONS.INTERNAL_REFERENCE,
  ],
  [orderConstants.DISTRIBUTION]: [
    aditionalOptionsConstants.ADITIONAL_OPTIONS.COMMENT_FOR_TRANSPORTIST,
    aditionalOptionsConstants.ADITIONAL_OPTIONS.INTERNAL_REFERENCE,
  ],
  [orderConstants.COLLECTION]: [
    aditionalOptionsConstants.ADITIONAL_OPTIONS.COMMENT_FOR_TRANSPORTIST,
    aditionalOptionsConstants.ADITIONAL_OPTIONS.INTERNAL_REFERENCE,
  ],
  [orderConstants.DIRECT_ORDER_RECURRING]: [
    aditionalOptionsConstants.ADITIONAL_OPTIONS.COMMENT_FOR_TRANSPORTIST,
  ],
};

const INSURANCE_OPTION = {
  [orderConstants.DIRECT_ORDER]: true,
  [orderConstants.DIRECT_ORDER_RECURRING]: false,
};

const AditionalOptions = ({
  className,
  shipmentKey,
  t,
  insurance,
  stopType,
  isRecurring,
  isEditing,
  orderType,
  hasAppointment,
}) => {
  const hideInternalReference =
    (orderType === orderConstants.COLLECTION && stopType === 'dropoff') ||
    (orderType === orderConstants.DISTRIBUTION && stopType === 'pickup') ||
    orderType === orderConstants.DIRECT_ORDER_RECURRING ||
    (orderType === orderConstants.DIRECT_ORDER && stopType === 'pickup');
  const internalReference =
    aditionalOptionsConstants.ADITIONAL_OPTIONS.INTERNAL_REFERENCE;
  return (
    <div className={className}>
      {hasAppointment && (
        <AditionalOption
          key={'APPOINTMENT_INSTRUCTIONS'}
          name={'APPOINTMENT_INSTRUCTIONS'}
          shipmentKey={shipmentKey}
          t={t}
          isRecurring={isRecurring}
        />
      )}
      {OPTIONS[orderType].map((option) => {
        return (
          <>
            {!(option === internalReference && hideInternalReference) && (
              <AditionalOption
                stopType={stopType}
                key={option}
                name={option}
                shipmentKey={shipmentKey}
                t={t}
                isRecurring={isRecurring}
              />
            )}
          </>
        );
      })}
      {insurance && isEditing && !INSURANCE_OPTION[orderType] && (
        <DiffInsured />
      )}
    </div>
  );
};

AditionalOptions.propTypes = {
  className: PropTypes.string,
  shipmentKey: PropTypes.string.isRequired,
  t: PropTypes.func,
  insurance: PropTypes.bool,
  isRecurring: PropTypes.bool,
  isEditing: PropTypes.bool,
  hasAppointment: PropTypes.bool,
};

AditionalOptions.defaultProps = {
  className: '',
  t: () => {},
  insurance: false,
  isRecurring: false,
  isEditing: false,
};

export default AditionalOptions;
